// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"35b76c7e","488":"6e3aa684","977":"3504a4f9"}[chunkId] + ".chunk.js";
};